import { ReactNode } from 'react';
import { Header, Page } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import QetaTitle from './QetaTitle';

const useStyles = makeStyles({
  content: {
    gridArea: 'pageContent',
    minWidth: 0,
    // Qeta renders its own <Page>; let the outer page own height and scrolling
    // so the banner scrolls with the content and sticky sidebars still work.
    '& [data-backstage-core-page]': {
      height: 'auto',
      overflowY: 'visible',
    },
  },
});

type QetaPageWithHeaderProps = {
  children: ReactNode;
};

/** Classic themed banner around the qeta page, matching the pre-4.x look. */
export const QetaPageWithHeader = ({ children }: QetaPageWithHeaderProps) => {
  const classes = useStyles();

  return (
    <Page themeId="tool">
      <Header title="Questions">
        <QetaTitle />
      </Header>
      <div className={classes.content}>{children}</div>
    </Page>
  );
};
